var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M24 13.867C24 15.045 22.977 16 21.714 16H2.286C1.023 16 0 15.045 0 13.867V2.133C0 .955 1.023 0 2.286 0h19.428C22.977 0 24 .955 24 2.133v11.734z",
    transform: "translate(-852 -1481) translate(81 1463) translate(771 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M15.429 2.667c-3.156 0-5.715 2.387-5.715 5.333s2.559 5.333 5.715 5.333c3.155 0 5.714-2.387 5.714-5.333s-2.559-5.333-5.714-5.333z",
    transform: "translate(-852 -1481) translate(81 1463) translate(771 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "M10.865 11.2c-.265-.33-.493-.685-.672-1.067h3.043c.159-.339.283-.695.364-1.066H9.83c-.076-.345-.116-.701-.116-1.067h4c0-.366-.04-.722-.115-1.067H9.83c.081-.37.205-.727.364-1.066h3.043c-.179-.382-.406-.738-.672-1.067h-1.699c.25-.31.532-.598.846-.85C10.713 3.15 9.418 2.666 8 2.666 4.844 2.667 2.286 5.054 2.286 8S4.844 13.333 8 13.333c1.868 0 3.521-.84 4.563-2.133h-1.698z",
    transform: "translate(-852 -1481) translate(81 1463) translate(771 18) translate(0 4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.66458aadfb6c4e176e5e372e7eb7ee98.svg";
export { ForwardRef as ReactComponent };